import { colord } from "colord";

/**
 * Gibt die optimale Kontrastfarbe zurück (schwarz oder weiß)
 * basierend auf der Helligkeit der Hintergrundfarbe
 */
export function getContrastColor(color: string): "black" | "white" {
  return colord(color).isLight() ? "black" : "white";
}

/**
 * Gibt eine aufgehellte Version der Farbe zurück
 */
export function lightenColor(color: string, amount: number): string {
  return colord(color).lighten(amount).toHex();
}

/**
 * Gibt eine abgedunkelte Version der Farbe zurück
 */
export function darkenColor(color: string, amount: number): string {
  return colord(color).darken(amount).toHex();
}
